import React from 'react';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { format } from 'date-fns';
import { Track, TrackArtist, TrackRelease } from '../../api';
import {
  TextBold14,
  TextRegular12,
  TextRegular14,
} from '../../VuexyDesign/atoms/Text';

const GetTrackInfoOwnerData = ({
  track,
  release,
  contributors,
  otherArtists,
}: GetTrackInfoOwnerDataProps) => {
  const { t } = useTranslation('tracks');

  return (
    <>
      <div className="d-flex flex-column">
        {track.release_status === 'live' ? (
          <>
            <TextRegular12 className="text-secondary mb-1">
              {t('tracks:releasedOn') as string}{' '}
              {format(
                new Date(release.finish.original_release_date),
                'd MMMM yyyy',
              )}
            </TextRegular12>
          </>
        ) : (
          <></>
        )}

        {contributors.length > 0 && (
          <TextRegular14>
            {t('tracks:writtenBy') as string}{' '}
            {contributors
              .map<React.ReactNode>((contributor) =>
                contributor.user_id === track.user.id ? (
                  <TextRegular14>{contributor.real_name}</TextRegular14>
                ) : (
                  <Link href={`/profile/${contributor.user_id}`}>
                    <TextBold14>{contributor.real_name}</TextBold14>
                  </Link>
                ),
              )
              .reduce((prev, curr) => [prev, ', ', curr])}
          </TextRegular14>
        )}
        {otherArtists.length > 0 && (
          <TextRegular14>
            {t('tracks:performedBy') as string}{' '}
            {otherArtists
              .map<React.ReactNode>((artist) =>
                artist.user_id === track.user.id ? (
                  <TextRegular14>{artist.artist_name}</TextRegular14>
                ) : (
                  <Link href={`/profile/${artist.user_id}`}>
                    <TextBold14 className="cursor-pointer">
                      {artist.artist_name}
                    </TextBold14>
                  </Link>
                ),
              )
              .reduce((prev, curr) => [prev, ', ', curr])}
          </TextRegular14>
        )}
      </div>
    </>
  );
};

export default GetTrackInfoOwnerData;

interface GetTrackInfoOwnerDataProps {
  track: Track;
  release: TrackRelease;
  contributors: TrackArtist[];
  otherArtists: TrackArtist[];
}
